import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./project_detail.css";
import {
  Clock,
  Calendar,
  Layers,
  ChevronRight,
  AlertCircle,
  FileText
} from "lucide-react";

const ProjectDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { project, totalStats } = location.state || {};
  const stats = totalStats || { formattedHours: "0 hr: 0 mins", formattedDays: "0 day" };

  if (!project) {
    return (
      <div className="project-detail-container">
        <div className="detail-card">
          <p>No project data found. Please go back and try again.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="project-detail-container">
      <div className="detail-header">
        <div className="header-left">
          <h2>{project.projectname}</h2>
          <p>Project Management System</p>
        </div>
        <div className="project-id-badge">ID: {project.projectid}</div>
      </div>

      <div className="detail-grid">
        <div className="left-side">
          <div className="detail-card">
            <h3>Project Overview</h3>
            <div className="description-box">
              {project.description || "No description provided for this project."}
            </div>
          </div>

          <div className="detail-card professional-modules-card">
            <div className="card-header-with-icon">
              <Layers size={20} className="header-icon" />
              <h3>Assigned Modules</h3>
            </div>
            <div className="modules-list-container">
              {project.modules?.map((mod) => (
                <div key={mod.assignmentid} className="professional-module-item">
                  <div className="module-top-header">
                    <div className="module-title-wrapper">
                      <div className="module-badge">
                        <FileText size={14} />
                      </div>
                      <h4>{mod.modulename}</h4>
                    </div>
                    <span className={`status-pill ${mod.status || 'progress'}`}>
                      {mod.status || 'In Progress'}
                    </span>
                  </div>

                  <p className="module-desc-text">
                    {mod.description || "No specific instructions provided for this module."}
                  </p>

                  <div className="module-details-grid">
                    <div className="detail-pill">
                      <AlertCircle size={14} className="pill-icon" />
                      <span className="pill-label">Priority:</span>
                      <span className={`pill-value prio-${mod.priority?.toLowerCase()}`}>
                        {mod.priority || 'Medium'}
                      </span>
                    </div>
                    <div className="detail-pill">
                      <Calendar size={14} className="pill-icon" />
                      <span className="pill-label">Deadline:</span>
                      <span className="pill-value date">
                        {mod.deadlinedate ? new Date(mod.deadlinedate).toLocaleDateString("en-GB") : "N/A"}
                      </span>
                    </div>
                  </div>

                  <div className="module-actions">
                    <button
                      className="professional-add-btn"
                      onClick={() =>
                        navigate("/add-workreports", {
                          state: {
                            projectid: project.projectid,
                            moduleid: mod.moduleid,
                          },
                        })
                      }
                    >
                      <span>Add Work Report</span>
                      <ChevronRight size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="right-side">
          <div className="detail-card">
            <h3>Total Performance Stats</h3>
            <div className="stats-card">
              <div className="stat-item">
                <div className="stat-icon" style={{ color: "#10B981" }}>
                  <Calendar size={24} />
                </div>
                <div className="stat-info">
                  <label>Total Worked Days</label>
                  <p>{stats.formattedDays}</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon" style={{ color: "#eb006a" }}>
                  <Clock size={24} />
                </div>
                <div className="stat-info">
                  <label>Total Worked Hours</label>
                  <p>{stats.formattedHours}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
